import { useEffect } from "react";
import { useHost } from "@xingternal/crate-core-runtime-helper";
import { registerExperiment } from "@xingternal/splitkit";
const useRegisterExperiments = () => {
  const host = useHost();
  const metadata = host.getXingletMetadata();
  useEffect(() => {
    metadata.forEach((data) => {
      var _a;
      ((_a = data.contributes) == null ? void 0 : _a.experiments) && data.contributes.experiments.forEach(({ name, supportedVariants }) => {
        registerExperiment(name, supportedVariants);
      });
    });
  }, []);
};
export {
  useRegisterExperiments
};
